import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Einheitliches Verfügbarkeits-Badge für alle Produktkacheln und Produktdetailseiten
 * Neues Design: Farblich abgestimmte Badges mit sanften Hintergrundfarben
 * 
 * @param {number|null} stockQuantity - Lagerbestand (null = 10 als Default)
 * @param {string} className - Zusätzliche CSS-Klassen (optional)
 */
const AvailabilityBadge = ({ stockQuantity, inquiryOnly = false, className = '' }) => {
  const { t } = useTranslation();
  const stock = stockQuantity ?? 10;
  
  if (stock === 0) {
    return (
      <span className={`bg-blue-50 text-blue-700 border border-blue-200 text-[10px] sm:text-xs font-medium px-2 py-1 rounded-full flex items-center gap-1.5 shadow-sm ${className}`}>
        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
        {inquiryOnly ? 'Auf Anfrage' : t('nav.vorbestellen')}
      </span>
    );
  }
  
  if (stock <= 2) {
    return (
      <span className={`bg-orange-50 text-orange-700 border border-orange-200 text-[10px] sm:text-xs font-medium px-2 py-1 rounded-full flex items-center gap-1.5 shadow-sm ${className}`}>
        <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
        {t('products.limitedStock', { count: stock })}
      </span>
    );
  }
  
  return (
    <span className={`bg-green-50 text-green-700 border border-green-200 text-[10px] sm:text-xs font-medium px-2 py-1 rounded-full flex items-center gap-1.5 shadow-sm ${className}`}>
      <span className="w-2 h-2 bg-green-500 rounded-full"></span>
      {t('products.available')}
    </span>
  );
};

export default AvailabilityBadge;
